<template>
  <div class="dashboard-tab">
    <h3 class="tab-title">订单管理</h3>
    
    <!-- 订单状态筛选 -->
    <div class="order-filter" >
      
      <!-- 订单处理状态 -->
      <el-button-group style="margin-left: 10px;width: 100%;">
        <el-button 
          :type="filterOrderStatus === '' ? 'primary' : 'default'"
          @click="handleFilterChange('order', '')"
        >
          全部状态
        </el-button>
        <el-button 
          :type="filterOrderStatus === 0 ? 'primary' : 'default'"
          @click="handleFilterChange('order', 0)"
        >
          待处理
        </el-button>
        <el-button 
          :type="filterOrderStatus === 1 ? 'primary' : 'default'"
          @click="handleFilterChange('order', 1)"
        >
          已完成
        </el-button>
        <el-button 
          :type="filterOrderStatus === 2 ? 'primary' : 'default'"
          @click="handleFilterChange('order', 2)"
        >
          已取消
        </el-button>
      </el-button-group>
      
      <div class="filter-right"  style="flo">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索订单号"
          style="width: 200px; margin-right: 10px;"
          clearable
          @clear="handleSearch"
          @keyup.enter="handleSearch"
        >
          <template #prefix>
            <svg t="1787718154634" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2008" width="16" height="16"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6c3.2 3.2 8.4 3.2 11.6 0l43.6-43.5c3.2-3.2 3.2-8.4 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" fill="#1296db" p-id="2009"></path></svg>
          </template>
        </el-input>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 300px; margin-right: 10px;"
          @change="handleDateChange"
        />
        <el-button type="primary" @click="handleSearch">
          搜索
        </el-button>
        <el-button @click="resetFilters">
          重置
        </el-button>
      </div>
    </div>
    
    <!-- 订单列表 -->
    <div class="order-list">
      <el-table 
        :data="orders" 
        style="width: 100%"
        v-loading="loading"
        empty-text="暂无订单"
        @sort-change="handleSortChange"
      >
        <el-table-column prop="order_no" label="订单号" width="200" sortable="custom">
          <template #default="{ row }">
            <div class="order-no">{{ row.order_no }}</div>
            <div class="order-time">创建时间：{{ formatTime(row.created_at) }}</div>  
            <div class="order-time">更新时间：{{ formatTime(row.updated_at) }}</div>                 
            <div class="order-time">支付时间：{{ formatTime(row.payment_time) }}</div>             
          </template>
        </el-table-column>
        
        <el-table-column prop="items" label="商品信息"  width="200">
          <template #default="{ row }">
            <div class="item-names">{{ row.item_names || '无商品信息' }}</div>
            <div class="item-count" v-show="row.item_names">共 {{ row.items.length || 0 }} 件商品</div>
          </template>
        </el-table-column>
        
        <el-table-column prop="totalAmount" label="金额" width="150" sortable="custom">
          <template #default="{ row }">
            <div class="amount">
              <div class="original">原价：¥{{ formatPrice(row.total_amount) }}</div>
              <div v-if="row.discount_amount > 0" class="discount_amount">
                优惠：-¥{{ formatPrice(row.discount_amount) }}
              </div>
              <div >应付：¥{{ formatPrice(row.payable_amount) }}</div>
              <div class="payable">实付：¥{{ formatPrice(row.paid_amount
) }}</div>              
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="paymentStatus" label="支付状态" width="120" >
          <template #default="{ row }">
            <div style="text-align:center; width: 100%;">
                <el-tag :type="getPaymentStatusTagType(row.payment_status)"
                >
                  {{ row.status_text || getPaymentStatusText(row.payment_status) }}
                </el-tag>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="order_status" label="订单状态" width="100"  style="text-align:center">
          <template #default="{ row }">
            <div style="text-align:center; width: 100%;">
               <el-tag :type="getOrderStatusTagType(row.order_status)">
                 {{ getOrderStatusText(row.order_status) }}
                </el-tag>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column label="支付方式" width="180" style="text-align:center">
          <template #default="{ row }">
            <div v-if="row.payment_method" class="payment-info" style="text-align:center">
              <div>{{ row.payment_method === 'alipay' ? '支付宝' : '微信' }}</div>
              <div v-if="row.paymentTime" class="payment-time">
                {{ formatTime(row.paymentTime) }}
              </div>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" width="280" fixed="right" style="text-align:center">
          <template #default="{ row }">
            <div class="order-actions" style="text-align:center">
              <!-- 继续支付按钮 -->
              <el-button 
                v-if="canPayOrder(row)"
                type="primary" 
                size="small"
                @click="payOrder(row)"
              >
                继续支付
              </el-button>
              
              <!-- 取消订单按钮 -->
              <el-button 
                v-if="canCancelOrder(row)"
                type="danger" 
                size="small"
                plain
                @click="cancelOrder(row)"
              >
                取消订单
              </el-button>
              
              <!-- 删除订单按钮 -->
              <el-button 
                v-if="canDeleteOrder(row)"
                type="danger" 
                size="small"
                plain
                @click="deleteOrder(row)"
              >
                删除订单
              </el-button>              
              <!-- 重新购买按钮 -->
              <el-button 
                v-if="canRenewOrder(row)"
                type="success" 
                size="small"
                @click="renewOrder(row)"
              >
                重新购买
              </el-button>
              
              <!-- 详情按钮 -->
              <el-button 
                type="default" 
                size="small"
                @click="viewOrderDetail(row)"
              >
                详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination" v-if="total > 0">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>
    
    <!-- 订单详情弹窗 -->
    <el-dialog
     :visible.sync="detailVisible" 
      v-model="currentOrder"
      title="订单详情"
      width="800px"
>        
        <Order-detail 
          v-if="detailVisible" 
          :order="currentOrder"
          @refresh="loadOrders"
        />
      </el-dialog>
  </div>
</template>

<script>
import { 
  getOrdersByTenant, 
  cancelPreOrder, 
  getOrderDetail,
  removeOrder
} from '@/api/tenant/order'
//import { formatToBeijingTime } from '@/util/date';
import OrderDetail from './order-detail.vue'

export default {
  name: 'OrderList',
  components: {
    OrderDetail
  },
  data() {
    return {
      orders: [],
      loading: false,
      
      // 筛选条件
      filterPaymentStatus: '',
      filterOrderStatus: '',
      searchKeyword: '',
      dateRange: [],
      startTime: null,
      endTime: null,
      sortField: 'createdAt',
      sortOrder: 'desc',
      
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
      
      // 详情相关
      detailVisible: false,
      currentOrder: null
    }
  },
  computed: {
    tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
    }
  },
  mounted() {
    this.loadOrders()
  },
  methods: {
    // 加载订单列表
    async loadOrders() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          sortField: this.sortField,
          sortOrder: this.sortOrder
        }
        
        // 添加筛选条件
        if (this.filterPaymentStatus !== '') {
          params.paymentStatus = this.filterPaymentStatus
        }
        if (this.filterOrderStatus !== '') {
          params.orderStatus = this.filterOrderStatus
        }
        if (this.searchKeyword) {
          params.keyword = this.searchKeyword
        }
        if (this.startTime) {
          params.startTime = this.startTime
        }
        if (this.endTime) {
          params.endTime = this.endTime
        }
        
        const response = await getOrdersByTenant(params)
        console.log(response)
        
        if (response.code === 200 && response.data) {
          this.orders = response.data.data || []
          this.total = response.data.total || 0
          this.totalPages = response.data.totalPages || 0

          console.log("orders", this.orders);
        } else {
          this.$message.error(response.message || '加载订单失败')
        }
      } catch (error) {
        console.error('加载订单失败:', error)
        this.$message.error('加载订单失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    
    // 处理筛选变化
    handleFilterChange(type, value) {
      if (type === 'payment') {
        this.filterPaymentStatus = value
      } else if (type === 'order') {
        this.filterOrderStatus = value
      }
      this.currentPage = 1
      this.loadOrders()
    },
    
    // 处理搜索
    handleSearch() {
      this.currentPage = 1
      this.loadOrders()
    },
    
    // 处理日期变化
    handleDateChange(dates) {
      if (dates && dates.length === 2) {
        this.startTime = dates[0].getTime()
        this.endTime = dates[1].getTime()
      } else {
        this.startTime = null
        this.endTime = null
      }
      this.currentPage = 1
      this.loadOrders()
    },
    
    // 重置筛选
    resetFilters() {
      this.filterPaymentStatus = ''
      this.filterOrderStatus = ''
      this.searchKeyword = ''
      this.dateRange = []
      this.startTime = null
      this.endTime = null
      this.sortField = 'createdAt'
      this.sortOrder = 'desc'
      this.currentPage = 1
      this.loadOrders()
    },
    
    // 处理排序
    handleSortChange({ prop, order }) {
      if (prop) {
        this.sortField = prop
        this.sortOrder = order === 'ascending' ? 'asc' : 'desc'
        this.loadOrders()
      }
    },
    
    // 分页变化
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadOrders()
    },
    
    handlePageChange(page) {
      this.currentPage = page
      this.loadOrders()
    },
    
    // 格式化价格
    formatPrice(price) {
      if (price === null || price === undefined) return '0.00'
      return parseFloat(price).toFixed(2)
    },
    
    // 格式化时间
formatTime(timestamp) {
  if (!timestamp) return ''
  const date = new Date(timestamp)
  if (isNaN(date.getTime())) return ''
  
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
},
    
    // 计算过期时间
    calculateExpireTime(createTime) {
      if (!createTime) return ''
      const expireTime = new Date(createTime).getTime() + 15 * 60 * 1000
      const now = Date.now()
      const diff = expireTime - now
      
      if (diff <= 0) return '已过期'
      
      const minutes = Math.floor(diff / (60 * 1000))
      const seconds = Math.floor((diff % (60 * 1000)) / 1000)
      return `${minutes}分${seconds}秒`
    },
    
    // 获取支付状态文本
    getPaymentStatusText(status) {
      const statusMap = {
        0: '待支付',
        1: '支付中',
        2: '已支付',
        3: '支付失败',
        4: '已退款'
      }
      return statusMap[status] || '未知'
    },
    
    // 获取订单状态文本
    getOrderStatusText(status) {
      const statusMap = {
        0: '待处理',
        1: '已完成',
        2: '已取消'
      }
      return statusMap[status] || '未知'
    },
    
    // 获取支付状态标签类型
    getPaymentStatusTagType(status) {
      const typeMap = {
        0: 'warning',  // 待支付
        1: 'info',     // 支付中
        2: 'success',  // 已支付
        3: 'danger',   // 支付失败
        4: 'info'      // 已退款
      }
      return typeMap[status] || 'info'
    },
    getOrderTime(order) {
      return order.createdAt || order.created_at;
    },
    // 获取订单状态标签类型
    getOrderStatusTagType(status) {
      const typeMap = {
        0: 'info',     // 待处理
        1: 'success',  // 已完成
        2: 'danger'    // 已取消
      }
      return typeMap[status] || 'info'
    },
    
    // 检查是否可以支付（只允许支付中或支付失败的订单）
  canPayOrder(order) {
    // 只允许支付状态为0（待支付）的订单
    if (order.payment_status !== 0) {
      return false;
    }
    
    // 订单状态必须是待处理
    if (order.order_status !== 0) {
      return false;
    }
    
    // 检查是否过期（15分钟）
    const createTime = order.createdAt || order.created_at;
    if (!createTime) return false;
    
    const expireTime = new Date(createTime).getTime() + 15 * 60 * 1000;
    return Date.now() < expireTime;
  },    
   // 检查是否可以取消
    canCancelOrder(order) {
      // 必须是待支付状态
      if (order.payment_status !== 0) return false;
      
      // 必须是待处理状态
      if (order.order_status !== 0) return false;
      
      // 检查是否过期（15分钟）
      const createTime = this.getOrderTime(order);
      if (!createTime) return false;
      
      const expireTime = new Date(createTime).getTime() + 15 * 60 * 1000;
      return Date.now() < expireTime;
    },
     // 检查是否可以删除
    canDeleteOrder(order) {
      console.log("canDeleteOrder", order)
      // 不能删除已完成订单
      if ((order.order_status === 1 ) || this.tenantInfo.status!=='APPROVED') return false;      
      return true;
    },
    deleteOrder(order){
      console.log("deleteOrder", order)
      this.$confirm("确认删除该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.loading = true;
        removeOrder( order.id).then(response => {
          console.log(response)
          if (response.data.code === 200) {
            this.$message.success('删除成功');
          } else {
            this.$message.error(response.data.message || "删除失败");
          }
          this.loadOrders();
          this.loading = false;
        }).catch(error => {
          console.error("删除失败:", error);
          this.loading = false;
        });
      }).catch(() => {
        this.loading = false;
      });
    },
  // 检查是否可以重新购买（已取消的超时订单）
  canRenewOrder(order) {
    console.log("canRenewOrder", order);
    // 必须是已取消状态
    if (order.order_status !== 2) return false;
    
    // 检查取消原因是否为支付超时
    const cancelReason = order.cancel_reason || order.cancelReason;
    return cancelReason && cancelReason.includes('支付超时');
  },
  
    // 重新购买订单
  async renewOrder(order) {
    try {
      console.log("重新购买订单:", order.order_no);
      
      // 简单验证（前端二次确认）
      if (!this.canRenewOrder(order)) {
        this.$message.warning('此订单不可重新购买');
        return;
      }
      
      // 直接跳转到支付页面，使用原订单号
      this.$router.push({
        path: '/admin/order/checkout',
        query: { 
          orderNo: order.order_no,
          from: 'renew'  // 标记为重新购买
        }
      });
      
    } catch (error) {
      console.error('重新购买失败:', error);
      this.$message.error('重新购买失败: ' + (error.message || '未知错误'));
    }
  },
    
    // 转换OrderItem到购物车格式
    convertOrderItemsToCartItems(orderItems) {
      if (!orderItems || orderItems.length === 0) return [];
      
      const tenantId = this.tenantInfo?.id || 0;
      
      return orderItems.map(item => {
        // 关键：字段名映射
        // OrderItem字段（下划线） → 购物车字段（驼峰）
        const cartItem = {
          id: item.id || 0,
          tenantId: tenantId,
          itemType: item.item_type || item.itemType, // 支持两种格式
          itemId: item.item_id || item.itemId,       // 关键：item_id → itemId
          itemName: item.item_name || item.itemName,
          quantity: item.quantity || 1,
          unitPrice: item.unit_price || item.unitPrice, // 关键：unit_price → unitPrice
          originalPrice: item.unit_price || item.unitPrice,
          totalPrice: (item.unit_price || item.unitPrice || 0) * (item.quantity || 1),
          discountAmount: 0,
          finalPrice: (item.unit_price || item.unitPrice || 0) * (item.quantity || 1),
          subtotal: item.subtotal || (item.unit_price || item.unitPrice || 0) * (item.quantity || 1),
          selected: true,
          cartStatus: 1,
          cartVersion: 0
        };
        
        console.log("转换订单项:", item, "→", cartItem);
        return cartItem;
      });
    },    
    // 支付订单
  async payOrder(order) {
    try {
      // 检查是否可支付
      if (!this.canPayOrder(order)) {
        this.$message.warning('订单已过期，无法支付');
        return;
      }
      
      // 跳转到支付页面
      this.$router.push({
        path: '/admin/order/checkout',
        query: { 
          orderNo: order.order_no,
          from: 'continue'  // 标记为继续支付
        }
      });
    } catch (error) {
      console.error('跳转支付页面失败:', error);
      this.$message.error('跳转失败: ' + (error.message || '未知错误'));
    }
  },
    
    // 取消订单
    async cancelOrder(order) {
      if (!this.canCancelOrder(order)) {
        this.$message.warning('订单无法取消')
        return
      }
      
      try {
        await this.$confirm('确定要取消此订单吗？取消后无法恢复。', '提示', {
          confirmButtonText: '确定取消',
          cancelButtonText: '再想想',
          type: 'warning'
        })
        
        const response = await cancelPreOrder(order.orderNo)
        
        if (response.code === 200) {
          this.$message.success('订单已取消')
          this.loadOrders()
        } else {
          this.$message.error(response.message || '取消订单失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消订单失败:', error)
          this.$message.error('取消订单失败: ' + (error.message || '未知错误'))
        }
      }
    },
    
    // 查看订单详情
    async viewOrderDetail(order) {
      console.log(order);
      try {
        this.loading = true
        const response = await getOrderDetail(order.order_no)
        console.log(response);
        if (response.code === 200) {
          this.currentOrder = response.data;
          console.log(this.currentOrder)
          this.detailVisible = true
        } else {
          this.$message.error(response.message || '获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取详情失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    
    // 申请退款
    async applyRefund() {
      try {
        await this.$confirm('确定要申请退款吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // TODO: 调用退款接口
        this.$message.success('退款申请已提交')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('申请退款失败:', error)
        }
      }
    },
    
    // 重新支付
    async retryPayment() {
      try {
        // TODO: 调用重新支付接口
        this.$message.info('重新支付功能开发中')
      } catch (error) {
        console.error('重新支付失败:', error)
      }
    },
    
    // 处理弹窗关闭
    handleDialogClose() {
      this.currentOrder = null
    }
  }
}
</script>

<style scoped>
/* 保持原有样式，增加一些新的样式 */
.order-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.order-no {
  font-family: monospace;
  font-weight: bold;
  color: #409eff;
}

.order-time {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.amount .original {
  text-decoration: line-through;
  color: #999;
  font-size: 12px;
}

.amount .discount {
  color: #67c23a;
  font-size: 12px;
  margin: 2px 0;
}

.amount .payable {
  font-weight: bold;
  color: #e4393c;
  font-size: 14px;
}

.payment-info {
  font-size: 12px;
}

.payment-time {
  color: #999;
  margin-top: 2px;
}

.expire-time {
  font-size: 12px;
  color: #e6a23c;
  margin-top: 5px;
}

.order-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
</style>